import Crud from '@/stores/crudBase';
import api from '@/apis/fixedAsset/fAAdjustmentAPI.js';
var crud = new Crud('fAAdjustment', api);

const state = {
  ...crud.state,
  _config: {
    table: 'fa_adjustment',
    field: {
      key: 'ref_id',
      posted: 'is_posted',
    },
  },
};
const getters = {
  ...crud.getters,
};
const actions = {
  ...crud.actions,
};
const mutations = {
  ...crud.mutations,
};

export default {
  debug: process.env.NODE_ENV !== 'production',
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
